import React from "react";
import classNames from "classnames";
import { SelectDropdown } from "@toddle-edu/ds-web";

import { useI18n } from "Hooks";

import { NODE_SOURCE_OPTIONS } from "../../modules/stringConstants";
import classes from "./HeaderDropdown.scss";
import { getIsLearningCoursesEnabledForUnit } from "UnitPlans/modules/UnitViewModeUtils";

const prefixClass = classNames("text-body");
const HeaderDropdown = props => {
  const { onChange, selectedNodesSource } = props;

  const isLearningCourseEnabled = getIsLearningCoursesEnabledForUnit();

  const { t } = useI18n();
  const renderDropdownPrefix = () => {
    return (
      <div className={prefixClass}>
        {t("scopeAndSequence:show_label_prefix", {
          label: t("common:standard_other"),
        })}
      </div>
    );
  };
  if (!isLearningCourseEnabled) return null;
  return (
    <div className={classes.headerDropdown}>
      <SelectDropdown
        prefix={renderDropdownPrefix()}
        options={NODE_SOURCE_OPTIONS(t)}
        onChange={onChange}
        isClearable={false}
        isSearchable={false}
        value={selectedNodesSource}
      />
    </div>
  );
};

export default HeaderDropdown;
